<ion-app><ion-router-outlet /></ion-app>
